import { Icon, Input, Title } from "@sicredi/react";
import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import { Partner } from "#/api/partnersShowcase/partnersShowcase";
import { useRouter } from "#/hocs/withRouter";
import { PAGE } from "#/constants";
import { useGetCategoryPartnerActive } from "#/requests/get-category-partner-active";
import {
  handlerDOM,
  returnTextFilterPartner,
  triggerOnInput,
} from "#/utils/searchInput";

declare global {
  interface Window {
    dataLayer: [Record<string, number | string>];
  }
}

export default function SearchInput() {
  const newRef = useRef<any>(null);
  const { handleGoNextPage } = useRouter();

  const [filterPartner, setfilterPartner] = useState<Partner[] | undefined>([]);
  const [partnerName, setPartnerName] = useState("");

  const { data } = useGetCategoryPartnerActive({
    partnerName,
    page: 0,
    options: {
      enabled: partnerName.trim().length >= 1,
    },
  });

  useEffect(() => {
    if (partnerName.trim().length < 1) {
      setfilterPartner([]);
      return;
    }

    const partners =
      data?.content
        ?.map((item) => {
          if (!item?.partner) {
            return undefined;
          }

          const partnerImage = item.partner.image;
          const image =
            partnerImage &&
            typeof partnerImage === "object" &&
            "mime" in partnerImage &&
            "data" in partnerImage
              ? partnerImage
              : undefined;

          return {
            ...item.partner,
            image,
            id: item.partner.id,
          };
        })
        .filter(Boolean) || [];

    setfilterPartner(partners as Partner[]);
  }, [data?.content, partnerName]);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleOutsideClick = (e: any) => {
    if (newRef.current && !newRef.current.contains(e.target)) {
      const results: any = document.getElementById("res");
      results.style.display = "none";
    }
  };

  function handlerPartner(
    name: string | undefined,
    id: string | undefined
  ): void {
    handlerDOM();
    handleGoNextPage(PAGE.PARTNER(), `/${name}/id=${id}PARTNERID/`);
  }

  return (
    <div ref={newRef} className={styles["content-search"]}>
      <Input
        required
        onInput={(value: any) => {
          const inputValue = value?.target?.value ?? "";
          setPartnerName(inputValue);
          triggerOnInput(value);
        }}
        className={styles["input-search"]}
        icon={<Icon name="search" />}
        name="example"
        type="search"
        placeholder=""
        label="Encontre um parceiro..."
        id="categories-partners"
        data-testid="categories-partners"
      />

      <div data-testid="res" id="res" className={`${styles["results"]}`}>
        <div className={styles["container-search"]}>
          <Title as="h4" weight="semi-bold" appearance="primary">
            {returnTextFilterPartner(filterPartner)}
          </Title>
          <div className={styles["items"]}>
            {filterPartner?.map((elem: Partner | undefined) => (
              <div
                data-testid={elem?.id}
                key={elem?.id}
                className={styles["item"]}
                onClick={() =>
                  handlerPartner(
                    elem?.legalPerson.nomeSocialFantasia ??
                      elem?.legalPerson.razaoSocial,
                    elem?.id
                  )
                }
              >
                {elem?.image?.mime && elem?.image?.data ? (
                  <img
                    width={32}
                    height={32}
                    src={`data:${elem.image.mime};base64, ${elem.image.data}`}
                    alt=""
                  />
                ) : null}
                <span>
                  {elem?.legalPerson?.nomeSocialFantasia ??
                    elem?.legalPerson.razaoSocial}
                </span>
                <hr />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
